/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const customerReactivateBodyExpectedCustomerVersionExclusiveMin = 0;
export const customerReactivateBodyExpectedCustomerVersionMax = 9007199254740991;

export const CustomerReactivateBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(customerReactivateBodyExpectedCustomerVersionExclusiveMin)
    .max(customerReactivateBodyExpectedCustomerVersionMax),
});

export type CustomerReactivateBody = zod.input<typeof CustomerReactivateBody>;
export type CustomerReactivateBodyOutput = zod.output<typeof CustomerReactivateBody>;
